import { Link } from 'react-router-dom';

const Downloads = () => {

    return (
        <>
            <div className="annualtitle">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-lg-6">
                            <div className="page-tit">
                                <h1>&nbsp;</h1>
                            </div>
                        </div>

                        <div className="col-md-12 col-lg-6">
                            <div className="breadcrumb-page">
                                <ul>
                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="#">Download</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container media-sec mt-20">
                <div className="row no-gutters">
                    <div className="col-md-12 col-sm-12 col-xs-12 m-2">
                        <ul className="list-group">
                            <a href="/download/brochure/Annual Return_Form_MGT_7A-22-23.pdf" target="_blank">
                                <li className="list-group-item">
                                    <h5>
                                        Annual Return_Form_MGT_7A-22-23
                                    </h5>
                                </li>
                            </a>
                            <a href="/download/brochure/Annual Return_Form_MGT_7A_21-22.pdf" target="_blank">
                                <li className="list-group-item">
                                    <h5>
                                        Annual Return_Form_MGT_7A_21-22
                                    </h5>
                                </li>
                            </a>
                        </ul>
                        <br></br><br></br>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Downloads;